import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error"; // Import Error icon
import { Typography, Box, Button } from "@mui/material";
import { getReserveById } from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";
import SupportWidget from "../../Components/Core/SupportWidget";

const ReserveDetail = ({ state, source }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [reservation, setReservation] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const from = source || location.state?.from || "/";
  const isConsultation = from === "Consultation";


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const ReserveData = await getReserveById(id);
      setReservation(ReserveData);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    document.title = isConsultation ? "خطا در پرداخت مشاوره" : "جزییات رزرو";
    if (state === "success") {
      fetchData();
    }
  }, [fetchData, state, isConsultation]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {state === "success" ? (
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <CheckCircleIcon color="success" style={{ fontSize: 100 }} />
              <Typography variant="h4" className="mb-4">
                <span>
                  {reservation?.firstName + " عزیز "}رزرو شما با موفقیت انجام شد
                </span>
              </Typography>
              <Typography variant="h6">
                <span>کد پیگیری: {reservation?.code}</span>
              </Typography>
              <Typography variant="h6">
                <span>
                  زمان رزرو:{" "}
                  {reservation?.dateDisplay + " ساعت " + reservation?.startTime}
                </span>
                <br />
                <br />
                <span className="text-bold">
                  زمان ویزیت اختصاص یافته به شما تقریبی می باشد. سعی ما بر این
                  است که در زمان مقرر ویزیت انجام شود اما ممکن است بنابر شرایط
                  مطب زمان انتظار برای ویزیت نیم تا یک ساعت طول بکشد. پیشاپیش از
                  شکیبایی شما سپاسگزاریم.
                </span>
              </Typography>
            </Box>
          ) : (
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <ErrorIcon color="error" style={{ fontSize: 100 }} />{" "}
              <Typography variant="h4" className="mb-4">
                <span>
                  {isConsultation
                    ? "پرداخت مشاوره با خطا مواجه شد. لطفا مجددا تلاش کنید"
                    : "پرداخت با خطا مواجه شد. لطفا مجددا تلاش کنید"}
                </span>
              </Typography>
              <Button
                variant="contained"
                color="primary"
                className="mt-4 fs-3"
                onClick={() => {
                  if (isConsultation) {
                    navigate("/counseling/index");
                    return;
                  }
                  navigate("/reservation/reserve");
                }}
              >
                {isConsultation ? (
                  <>
                    <span>برگشت به صفحه مشاوره</span>
                  </>
                ) : (
                  <>
                    <span>برگشت به صفحه رزرو</span>
                  </>
                )}
              </Button>
            </Box>
          )}
        </>
      )}
      <SupportWidget />
    </>
  );
};

export default ReserveDetail;
